module.exports = __webpack_public_path__ + "static/media/SplunkClusterAdmin.a18805a4.png";